<template>
  <div class="countDownForUser">
    <div class="card">
      <flip-countdown-ba v-if="hasTime" :props="this.props" :translation="this.translation"></flip-countdown-ba>
      <div class="btn__out">
        <a
          class="btn__active"
          :href="this.checkoutLink"
          v-if="!notShowActiveAcc"
        >{{translation.active_my_account}}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "countdown-for-user",
  props: ["props", "checkoutLink", "stepOne", "stepTwo", "stepThree"],
  data() {
    return {
      translation: this.$parent.$parent.view.translation.countdown,
      propsCountdown: {},
      hasTime: false,
      infoFirstAcess: null,
      isStepOne: false,
      isStepTwo: false,
      isStepThree: false,
      notShowActiveAcc: false,
    };
  },
  methods: {
    firstAccess(type) {
      const BASE_URI = `${window.location.origin}${window.location.pathname}`;
      axios
        .post(`${BASE_URI}/accessed-step`, {
            id: type
        })
        .then(response => {
          if (response.data.msg == "success") {
            this.infoFirstAcess = response.data.date;
          }
        })
        .catch(error => {
          console.log("erro", error, error.response);
        });
    }
  },
  created() {
    if ((this.props.data_limite - this.props.data_atual) > 0) {
      this.hasTime = true;
    } 
    if (this.stepOne) {
      this.isStepOne = true;
      this.notShowActiveAcc = true;
    } 
    if (this.stepTwo) {
      this.isStepTwo = true;
      this.firstAccess(2);
    } 
    if (this.stepThree) {
      this.isStepThree = true;
      this.notShowActiveAcc = true;
      this.firstAccess(3);
    } 
    if (this.stepThree && this.$parent.$parent.view.v1_funnel_challenge) {
      if(this.$parent.$parent.view.dados_usuario_office.pag_status != 'PAGO') {
        this.notShowActiveAcc = false;
      }
    } 
  },
  mounted() {
    // console.log(this.props);
    
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.countDownForUser{
  padding-left: 25px;

  .card{
    padding :18px 18px;
  }
}
.info__period {
  color: #818a91;
  margin-right: 1.4rem;
}
.btn__out {
  display: flex;
  justify-content: center;
  .btn__active {
    background: #24D67c;
    font-weight: 700;
    color: white;
    padding: 1.2rem 1.6rem;
    border-radius: 4px;
    margin-top: 1rem;
    transition: .3s all;
    font-size: 1.3rem;
    &:hover {
      background: #54d895;
    }
  }
}
</style>   


// WEBPACK FOOTER //
// resources/office/js/components/franchise/components/countdownForUser.vue